/* eslint-disable import/prefer-default-export */
import { createNavigation } from '../lib/utils'
import { OrganizationNavigation } from './OrganizationNavigation'

// TODO - fix correct dynamic type generation for autocomplete
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const LaunchNavigation = createNavigation([
  {
    name: 'launch',
    // TODO - fix type generation for basePath argument for createNavigation
    path: `${OrganizationNavigation.organization.launches.route.pathname}/[launchId]`,
    subroutes: [
      {
        name: 'calendar',
        path: '/calendar',
      },
      {
        name: 'connections',
        path: '/connections',
      },
      {
        name: 'assets',
        path: '/copy-and-assets',
        subroutes: [
          {
            name: 'asset',
            path: '/[assetId]',
          },
        ],
      },
      {
        name: 'gtmTimeline',
        path: '/gtm-timeline',
      },
      {
        name: 'measurements',
        path: '/measurements',
      },
      {
        name: 'missionControl',
        path: '/mission-control',
      },
      {
        name: 'missionControlV2',
        path: '/mission-control-v2',
      },
      {
        name: 'objectives',
        path: '/objectives',
      },
      {
        name: 'releaseNotes',
        path: '/release-notes',
      },
      {
        name: 'researchHub',
        path: '/research-hub',
      },
      {
        name: 'retrospectives',
        path: '/retrospectives',
      },
      {
        name: 'tasks',
        path: '/tasks',
        subroutes: [
          {
            name: 'task',
            path: '/[taskId]',
          },
        ],
      },
      {
        name: 'winLoss',
        path: '/win-loss',
      },
    ],
  },
] as const)
